import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import MyGiggers from './MyGiggers';

export default combineReducers({
  AppReducer,
  MyGiggers,
});
